export enum ThumbnailLayout {
    Contain = "Contain",
    Cover = "Cover",
}
